import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { navLinks, services } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="dark-grain relative overflow-hidden bg-primary text-primary-foreground">
    <div className="relative z-10 mx-auto max-w-7xl px-6 py-16 md:py-20">
      <div className="grid gap-12 lg:grid-cols-[1.2fr_0.8fr_0.8fr_1fr]">
        <div>
          <Link to="/" data-testid="footer-brand-link" className="inline-flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-full border border-secondary/50 font-serif text-xl italic">BJ</span>
            <span>
              <span className="block font-serif text-2xl">Bello Joy</span>
              <span className="block text-xs uppercase tracking-[0.3em] text-secondary">Consulting</span>
            </span>
          </Link>
          <p data-testid="footer-mission" className="mt-6 max-w-sm text-sm leading-relaxed text-primary-foreground/70">
            Faith-centered insurance and financial guidance for families and businesses across the United States.
          </p>
        </div>

        <div>
          <h3 className="mb-5 text-sm font-semibold uppercase tracking-[0.24em] text-secondary">Explore</h3>
          <div className="flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href} data-testid={`footer-${link.label.toLowerCase().replaceAll(" ", "-")}-link`} className="text-sm text-primary-foreground/70 transition-colors hover:text-secondary">
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-5 text-sm font-semibold uppercase tracking-[0.24em] text-secondary">Services</h3>
          <div className="flex flex-col gap-3">
            {services.slice(0, 5).map((service) => (
              <Link key={service.slug} to={`/services#${service.slug}`} data-testid={`footer-service-${service.slug}-link`} className="text-sm text-primary-foreground/70 transition-colors hover:text-secondary">
                {service.title}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h3 className="mb-5 text-sm font-semibold uppercase tracking-[0.24em] text-secondary">Begin a Conversation</h3>
          <a href="tel:+14696827618" data-testid="footer-phone-link" className="mb-4 flex items-center gap-3 text-sm text-primary-foreground/75 transition-colors hover:text-secondary">
            <Phone size={16} /> 469-682-7618
          </a>
          <a href="mailto:info@bellojoyconsulting.com" data-testid="footer-email-link" className="mb-6 flex items-center gap-3 text-sm text-primary-foreground/75 transition-colors hover:text-secondary">
            <Mail size={16} /> info@bellojoyconsulting.com
          </a>
          <Link to="/contact" data-testid="footer-consultation-link" className="inline-flex items-center gap-2 rounded-full border border-secondary/50 px-5 py-3 text-sm font-medium text-secondary transition-colors hover:bg-secondary hover:text-primary">
            Schedule a Consultation <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-primary-foreground/15 pt-6 text-xs text-primary-foreground/50 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Bello Joy Consulting. All rights reserved.</p>
        <p data-testid="footer-values">Faith in God • Family • Customers First</p>
      </div>
    </div>
  </footer>
);
